import { Dropdown, Space, Tag } from 'antd'
import { DownOutlined, EditOutlined } from '@ant-design/icons'
import { fDate, fDateTime, isValidArray } from '../forms/helper'

export const getColumns = (onAction) => {
    const statusColors = {
        Pending: 'orange',
        Pass: 'green',
        Fail: 'red',
        Retest: 'blue',
    }

    const menuItemsFor = (id) => [
        // { key: 'view', label: 'View', onClick: () => onAction('view', id) },
        { key: 'edit', label: 'Edit', onClick: () => onAction('edit', id) },
        // {
        //     key: 'delete',
        //     label: 'Delete',
        //     onClick: () => onAction('delete', id),
        // },
        {
            key: 'addResult',
            label: 'Add Result',
            onClick: () => onAction('addResult', id),
        },
    ]
    const columns = [
        { title: 'ID', dataIndex: 'testId', width: 110 },
        {
            title: 'Title',
            dataIndex: 'title',
            // maxWidth: 350,
            // width: 350,
            // ellipsis: true,
        },

        {
            title: 'Sprint',
            dataIndex: 'sprint',
            width: 150,
            render: (sprint) => <span>{sprint?.title || 'N/A'}</span>,
        },
        // {
        //     title: 'Epic',
        //     dataIndex: 'epic',
        //     width: 150,
        //     render: (epic) => <span>{epic?.title || 'N/A'}</span>,
        // },
        {
            title: 'Tags',
            dataIndex: 'tags',
            width: 300,
            render: (tags) => (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'flex-start',
                        flexWrap: 'wrap',
                        rowGap: 4,
                    }}
                >
                    {isValidArray(tags)
                        ? tags?.map((tag) => {
                              return (
                                  <Tag
                                      color={'purple'}
                                      key={tag}
                                      style={{ fontSize: 9, padding: '3px' }}
                                  >
                                      {tag?.name || 'N/A'}
                                  </Tag>
                              )
                          })
                        : 'N/A'}
                </div>
            ),
        },
        {
            title: 'Created At',
            dataIndex: 'createdAt',
            width: 100,
            render: (date) => fDate(date),
        },
        {
            title: 'Action',
            key: 'action',
            width: 100,
            render: (_text, record) => (
                <div
                    style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                    }}
                >
                    <EditOutlined
                        title="Edit"
                        onClick={() => onAction('edit', record._id)}
                    />
                    {/* <Dropdown
                        menu={{ items: menuItemsFor(record._id) }}
                        trigger={['click']}
                    >
                        <span
                            onClick={(e) => e.preventDefault()}
                            style={{ fontSize: 14, cursor: 'pointer' }}
                        >
                            More <DownOutlined style={{ fontSize: 12 }} />
                        </span>
                    </Dropdown> */}
                </div>
            ),
        },
    ]

    return columns
}
